// removed by extract-text-webpack-plugin
module.exports = {"number":"c-StepNumber__number","accent":"c-StepNumber__accent","withIcon":"c-StepNumber__withIcon"};